export default __webpack_public_path__ + "static/media/VisualBrief.250009cdfa3ca0d97e760298c23713ca.webp";